import axios from 'axios';
import { env } from '@/config';
import { logger } from './logger';

export const apiClient = axios.create({
  baseURL: env.apiBaseUrl,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - attach JWT token
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor - unwrap backend { data, statusCode, timestamp } format
apiClient.interceptors.response.use(
  (response) => {
    if (
      response.data &&
      typeof response.data === 'object' &&
      'data' in response.data &&
      'statusCode' in response.data
    ) {
      response.data = response.data.data;
    }
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('auth_token');
      localStorage.removeItem('auth_user');
      // The honorarac invite page has no session at all (issue #58): a stale
      // token from someone else's login on this browser must not bounce it.
      const publicPage =
        window.location.pathname === '/login' ||
        window.location.pathname.startsWith('/potvrda-rasporeda/');
      if (!publicPage) {
        window.location.href = '/login';
      }
    }
    logger.error('API error', error);
    return Promise.reject(error);
  }
);
